// Entry point

export const setComponentClasses = configs => {
  const classesObj = {
    background: '',
    main: '',
    article: '',
    header: '',
    body: '',
    footer: '',
  }

  switch (configs.cardType) {
    case 'testimonials':
      classesObj.main = 'hot-card--active _text-center _p-lg-7 _p-4 _h-full ' + configs.main.class
      classesObj.header = '_d-bloc '
      classesObj.body = 'text-4 _p-0 _d-block _font-weight-light _mb-6 '
      classesObj.footer = '_d-block _p-0 '
      break
    case 'vagasJobs':
      classesObj.main = 'border-radius-none box-shadow-cyan '
      classesObj.article = 'card left '
      classesObj.header = '_bg-brand-primary border-radius-none _p-0 ' + configs.header.class
      classesObj.body = '_bg-gray-100 _text-3 _px-5 _py-3 ' + configs.body.class
      classesObj.footer = '' + configs.footer.class
      break
    default:
      classesObj.background = configs.background
      classesObj.main = configs.main.class
      classesObj.article = configs.article.class
      classesObj.header = configs.header.class
      classesObj.body = configs.body.class
      classesObj.footer = configs.footer.class
      break
  }

  return classesObj
}
